<div class="marine-insurance-quote-updated-pricing" [ngClass]="{ 'is-with-margin-top': isWithMarginTop }">
  <div class="marine-insurance-quote-updated-pricing-body">
    <div class="row">
      <div class="col-12 col-xl-8">
        <div class="marine-insurance-quote-updated-pricing-body-details">
          <h3 class="marine-insurance-quote-updated-pricing-body-details-header">{{ "UPDATED_INSURANCE_PAYMENT_REQUEST" | translate }}</h3>

          <app-marine-insurance-quote-view-data
            [marineInsurance]="marineInsurance"
            [isShowUpdatedDate]="!!marineInsurance?.updatedShippingDate"
            [isShowUpdatedInsuredValue]="true"
            [isShowCertificate]="false"
          ></app-marine-insurance-quote-view-data>

          <p class="marine-insurance-quote-updated-pricing-body-details-hint">
            {{ "INSURANCE_QUOTE_UPDATED_BASED_ON_THE_INFORMATION_PROVIDED" | translate }}
          </p>

          <div class="marine-insurance-quote-updated-pricing-body-details-footer">
            <div class="marine-insurance-quote-updated-pricing-body-details-footer-terms-link" (click)="showTerms()">
              {{ "LEARN_MORE_TERMS_OF_COVERAGE" | translate }}

              <img class="ml-2" src="/assets/icons/icon_chevron_down_gray.svg" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-4 pl-xl-0">
        <app-marine-insurance-payment-breakdown [pendingBills]="pendingBills"></app-marine-insurance-payment-breakdown>

        <div class="w-100 text-center">
          <app-marine-insurance-payment-button
            [pendingBills]="pendingBills"
            [referenceNumber]="marineInsurance?.referenceNumber"
            [isPaymentAvailable]="true"
            [isDesktop]="true"
            [id]="'paypal-marine-insurance-updated-request-desktop'"
            (successPayment)="onSuccessPayment()"
          ></app-marine-insurance-payment-button>
        </div>
      </div>
    </div>

    <div class="marine-insurance-quote-updated-pricing-footer" *ngIf="isShowTerms">
      <div class="row">
        <div class="col-12">
          <div class="marine-insurance-quote-updated-pricing-footer-header">
            <h5 class="marine-insurance-quote-updated-pricing-footer-header-text">{{ "COVERAGE_DETAILS" | translate }}</h5>

            <span class="marine-insurance-quote-updated-pricing-footer-header-close" (click)="hideTerms()">
              <img class="mr-1" src="assets/icons/icon_close_gray_sm.svg" />
              <span>{{ "BUTTON.CLOSE" | translate }}</span>
            </span>
          </div>

          <app-marine-insurance-terms-data></app-marine-insurance-terms-data>
        </div>
      </div>
    </div>
  </div>
</div>
